<div class="updated-successfully">
  <div>
    <span class="cds-body-hero" style="font-weight: 300">Your changes has been updated</span>
    <span class="cds-body-hero" style="font-style: italic; font-weight: 400"> successfully.</span>
  </div>
  <div class="l-mt-7">
    <cds-button class="btn" (click)="onCancel()" [size]="'sm'">Got it!</cds-button>
  </div>
</div>
